/**
 * GB API
 * API for GB Component
 *
 * The version of the OpenAPI document: -
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GbGeschaeftId } from './gbGeschaeftId';
import { GeschaeftsnummerEntry } from './geschaeftsnummerEntry';


export interface BelegEntry { 
    geschaeftsnummer?: GeschaeftsnummerEntry;
    alt?: string;
    datum?: string;
    dokulinkVerfuegbar?: BelegEntry.DokulinkVerfuegbarEnum;
    isNavigierbar?: boolean;
    geschaeftId?: GbGeschaeftId;
}
export namespace BelegEntry {
    export type DokulinkVerfuegbarEnum = 'DOKULINK_VORHANDEN' | 'DOKULINK_NICHT_VORHANDEN';
    export const DokulinkVerfuegbarEnum = {
        VORHANDEN: 'DOKULINK_VORHANDEN' as DokulinkVerfuegbarEnum,
        NICHTVORHANDEN: 'DOKULINK_NICHT_VORHANDEN' as DokulinkVerfuegbarEnum
    };
}


